<template>
    <vx-card>
        <div class="vx-card " id="social-security">
        <!-- COLOUR ORDER IN DONUTS - GREEN, BLUE, RED -->
        <!-- Social-Security, Complemented, Not covers -->
        <!-- Use a 0 if we don't want to use that colour -->

            <div>

                <div class="vx-row modify-div" >
                    <div class="vx-col chart" v-if="temporaryDisability != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[temporaryDisability.value, 0, temporaryDisability.notCovered]"
                                v-bind:name="temporaryDisability.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="temporaryDisability.percentage"
                                v-bind:percentageCategory="temporaryDisability.percentageCategory"
                                v-bind:infoButton="'Cuando estás imposibilitado temporalmente para trabajar y recibes asistencia sanitaria de la Seguridad Social.'"
                                >
                            </generic-donut-chart>
                        </div>
                    </div>

                    <div class="vx-col chart" v-if="totalPermanentDisability != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[totalPermanentDisability.value, 0, totalPermanentDisability.notCovered]"
                                v-bind:name="totalPermanentDisability.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="totalPermanentDisability.percentage"
                                v-bind:percentageCategory="totalPermanentDisability.percentageCategory"
                                v-bind:infoButton="'Cuando una enfermedad o un accidente te inhabilita para tu profesión habitual, pero puedes dedicarte a otra distinta.'"
                                >

                            </generic-donut-chart>
                        </div>
                    </div>

                    <div class="vx-col chart" v-if="absolutePermanentDisability != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[absolutePermanentDisability.value, 0, (salaryMonth-absolutePermanentDisability.value)]"
                                v-bind:name="absolutePermanentDisability.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="absolutePermanentDisability.percentage"
                                v-bind:percentageCategory="absolutePermanentDisability.percentageCategory"
                                v-bind:infoButton="'Cuando una enfermedad o un accidente te inhabilita para toda profesión u oficio.'"
                                >
                            </generic-donut-chart>
                        </div>
                    </div>

                    <div class="vx-col chart" v-if="greatDisability != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[greatDisability.value, 0, (salaryMonth-greatDisability.value)]"
                                v-bind:name="greatDisability.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="greatDisability.percentage"
                                v-bind:percentageCategory="greatDisability.percentageCategory"
                                v-bind:infoButton="'Cuando estás incapacitado permanentemente y necesitas la asistencia de otra persona para los actos más esenciales de la vida.'"
                                >
                            </generic-donut-chart>
                        </div>
                    </div>

                    <div class="vx-col chart" v-if="widowhood != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[widowhood.value, 0, (salaryMonth*0.52-widowhood.value)]"
                                v-bind:name="widowhood.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="widowhood.percentage"
                                v-bind:percentageCategory="widowhood.percentageCategory"
                                v-bind:infoButton="'Si se produce el fallecimiento, pensión que percibirán las personas que hayan tenido contigo vínculo matrimonial o sido pareja de hecho y no hayan contraído nuevo matrimonio.'"
                                >
                            </generic-donut-chart>
                        </div>
                    </div>

                    <div class="vx-col chart" v-if="orphanhood != null">
                        <div class="w-full">
                            <generic-donut-chart
                                v-bind:seriesData="[orphanhood.value, 0, (salaryMonth*0.48-orphanhood.value)]"
                                v-bind:name="orphanhood.name"
                                v-bind:commercialOfferType="commercialOffer.type"
                                v-bind:percentage="orphanhood.percentage"
                                v-bind:percentageCategory="orphanhood.percentageCategory"
                                v-bind:infoButton="'Si se produce el fallecimiento, pensión que percibirán tus hijos, y los aportados por el cónyuge, que reúnan los requisitos exigidos.'"
                                >
                            </generic-donut-chart>
                        </div>
                    </div>

                </div>

                <div class="vx-row legend mb-10 mt-10" style="padding:0px" >
                    <div class="vx-col legend-label" style="display:flex">
                        <div class="box green"></div>
                        <label>Cobertura Seguridad Social</label>
                    </div>

                    <div class="vx-col legend-label" style="display:flex">
                        <div class="box red"></div>
                        <label>Ingresos sin cobertura</label>
                    </div>
                </div>
            </div>

            <navegation-buttons id="buttons"
                v-bind:code="code"
                v-bind:previus="previus"
                v-bind:next="next"
                @nextStep="goToNextStep()">
            </navegation-buttons>

            <!-- <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
                <call-service-popup
                    v-bind:callServicePopup="callServicePopup"
                    v-bind:callServiceType="callServiceType"
                    @closeCallServicePopup="closeCallServicePopup"
                >
                </call-service-popup>
            </vs-popup> -->
            <!-- <div class="box-buttons mt-10">
                <div class="back-button no-fill-button">
                    <vs-button
                    class="vs-button previous-product"
                    @click="goToPreviusStep()"
                    >
                    Anterior
                    </vs-button>
                </div>
                <div class="call-button no-fill-button">
                    <vs-button
                        @click="callService()"
                    >
                    <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                        Solicitar llamada
                    </vs-button>
                </div>

                <div class="next-button no-fill-button">
                    <vs-button
                        class="vs-button"
                        @click="goToNextStep()"
                    >
                    Siguiente</vs-button>
                </div>
            </div> -->

        </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import GenericDonutChart from '../generic-donut-chart/GenericDonutChart.vue'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue'

import vSelect from 'vue-select'
// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';


export default {
  components: { 
      VxCard, 
    //   CallServicePopup ,
      vSelect, 
      GenericDonutChart, 
      NavegationButtons
      },

    name: 'commercial-offer-social-security',
    props: {
        commercialOffer: Object,
        code: String,
        next: String,
        previus: String,
    },
    data() {
        return {
            // callServiceType:"helpProcess",
            // callServicePopup: false,
            dataStored: null,
            initialData: null,

            absolutePermanentDisability: null,
            temporaryDisability: null,
            greatDisability: null,
            totalPermanentDisability: null,
            orphanhood: null,
            widowhood: null,

            salaryYear: 0,
            salaryMonth: 0,

            needsCapital: null,

            capitalNeeded: [],

        }
    },
    created() {

        this.dataStored = JSON.parse(localStorage.getItem(this.code))

        if (this.dataStored.initialData) {
            this.initialData = this.dataStored.initialData
        }

        this.initForm();

    },
    methods: {
        initForm() {
            this.calculateSalaryMonth()
            this.calculateSocialSecurityOffer()

        },

        calculateSalaryMonth() {
            if(this.initialData.socialSecurityInput.specialRegimes){
                this.initialData.socialSecurityInput.specialRegimes.forEach(specialRegime => {
                    this.salaryYear = this.salaryYear + specialRegime.income
                })
            }

            if(this.initialData.socialSecurityInput.generalRegimes){
                this.initialData.socialSecurityInput.generalRegimes.forEach(generalRegime => {
                    this.salaryYear = this.salaryYear + generalRegime.income
                })
            }

            this.salaryMonth = this.salaryYear / 12
        },

        calculateSocialSecurityOffer(){

            this.$http.post(process.env.VUE_APP_BROKER_API + '/social-security', this.initialData.socialSecurityInput)
            .then((response) => {

                let socialSecurityOffer = response.data
                
                this.initializeResultsArray(socialSecurityOffer)
                });

            },

        initializeResultsArray(socialSecurityOffer){

            if (socialSecurityOffer.socialSecurityOutputs[0].absolutPermanentDisability) {

                this.absolutePermanentDisability = {
                        value: 0,
                        name: socialSecurityOffer.socialSecurityOutputs[0].absolutPermanentDisability.name,
                        notCovered: 0, 
                        percentage: 0,
                        percentageCategory: ""
                    }

                if (socialSecurityOffer.socialSecurityOutputs[0].absolutPermanentDisability.commonDisease) {
                    this.absolutePermanentDisability.value = socialSecurityOffer.socialSecurityOutputs[0].absolutPermanentDisability.commonDisease
                }

                this.absolutePermanentDisability.notCovered = this.salaryMonth - this.absolutePermanentDisability.value
                this.absolutePermanentDisability.percentage = this.calculatePercentage(this.absolutePermanentDisability)
                
                this.absolutePermanentDisability.percentageCategory = "withoutCover"
            }

            if (socialSecurityOffer.socialSecurityOutputs[0].totalPermanentDisability) {

                this.totalPermanentDisability = {
                    value: 0,
                    name: socialSecurityOffer.socialSecurityOutputs[0].totalPermanentDisability.name,
                    notCovered: 0, 
                    percentage: 0,
                    percentageCategory: ""
                }

                if (socialSecurityOffer.socialSecurityOutputs[0].totalPermanentDisability.commonDisease) {
                    this.totalPermanentDisability.value = socialSecurityOffer.socialSecurityOutputs[0].totalPermanentDisability.commonDisease
                }

                this.totalPermanentDisability.notCovered = this.salaryMonth - this.totalPermanentDisability.value
                this.totalPermanentDisability.percentage = this.calculatePercentage(this.totalPermanentDisability)

                this.totalPermanentDisability.percentageCategory = "withoutCover"
            }

            if (socialSecurityOffer.socialSecurityOutputs[0].greatDisability) {

                this.greatDisability = {
                        value: 0,
                        name: socialSecurityOffer.socialSecurityOutputs[0].greatDisability.name,
                        notCovered: 0, 
                        percentage: 0,
                        percentageCategory: ""
                    }

                if (socialSecurityOffer.socialSecurityOutputs[0].greatDisability.commonDisease) {
                    this.greatDisability.value = socialSecurityOffer.socialSecurityOutputs[0].greatDisability.commonDisease                    
                }

                this.greatDisability.notCovered = this.salaryMonth - this.greatDisability.value
                this.greatDisability.percentage = this.calculatePercentage(this.greatDisability)
                this.greatDisability.percentageCategory = "withoutCover"
            }


           if (socialSecurityOffer.socialSecurityOutputs[0].temporaryDisability) {

               this.temporaryDisability = {
                    value: 0,
                    name: socialSecurityOffer.socialSecurityOutputs[0].temporaryDisability.name,
                    notCovered: 0, 
                    percentage: 0,
                    percentageCategory: ""
                }

                if (socialSecurityOffer.socialSecurityOutputs[0].temporaryDisability.commonDisease) {
                    this.temporaryDisability.value = socialSecurityOffer.socialSecurityOutputs[0].temporaryDisability.commonDisease
                }

                this.temporaryDisability.notCovered = this.salaryMonth - this.temporaryDisability.value
                this.temporaryDisability.percentage = this.calculatePercentage(this.temporaryDisability)

                this.temporaryDisability.percentageCategory = "withoutCover"
            }

            if (socialSecurityOffer.socialSecurityOutputs[0].widowhood.commonDisease) {

                this.widowhood = {
                    value: socialSecurityOffer.socialSecurityOutputs[0].widowhood.commonDisease,
                    name: socialSecurityOffer.socialSecurityOutputs[0].widowhood.name,
                    notCovered: 0, 
                    percentage: 0,
                    percentageCategory: ""
                }

                this.widowhood.notCovered = this.salaryMonth - this.widowhood.value
                this.widowhood.percentage = this.calculatePercentage(this.widowhood)

                this.widowhood.percentageCategory = "withoutCover"
            }

            if (socialSecurityOffer.orphanhood.commonDisease) {

                this.orphanhood = {
                    value: socialSecurityOffer.orphanhood.commonDisease,
                    name: socialSecurityOffer.orphanhood.name,
                    notCovered: 0, 
                    percentage: 0,
                    percentageCategory: ""
                }

                this.orphanhood.notCovered = this.salaryMonth - this.orphanhood.value
                this.orphanhood.percentage = this.calculatePercentage(this.orphanhood)

                this.orphanhood.percentageCategory = "withoutCover"
            }

            let data = {
                absolutePermanentDisability: this.absolutePermanentDisability,
                totalPermanentDisability: this.totalPermanentDisability,
                greatDisability: this.greatDisability,
                temporaryDisability: this.temporaryDisability,
                widowhood: this.widowhood,
                orphanhood: this.orphanhood
            }

            this.dataStored.socialSecurity = data
        },

        calculatePercentage(socialSecurityValue){
            let value = null

            if (socialSecurityValue.name == "Viudedad") {
                value = ((this.salaryMonth*0.52 - socialSecurityValue.value) / (this.salaryMonth*0.52))*100

            } else if (socialSecurityValue.name == "Orfandad") {
                value = ((this.salaryMonth*0.48 - socialSecurityValue.value) / (this.salaryMonth*0.48))*100

            } else {
                value = ((this.salaryMonth - socialSecurityValue.value) / this.salaryMonth)*100
            }

            if(value > 0) {
                let percentage = value
                return percentage

            } else {
                let percentage =  0
                return percentage
            }


        },
                

        // callService() {
        //     this.callServicePopup = true;
        // },

        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },

        // goToPreviusStep() {
        //     this.$router
        //     .push("/"+ this.previus + "-step/" + this.code)
        //     .catch(() => {});

        // },

        goToNextStep() {
        // ApiBroker: capital == Social Security - saved as socialSecurity in this.capitalNeed
        // need == social security + complemented 
             this.$vs.loading({ type: "sound" });

            localStorage.setItem(this.code, JSON.stringify(this.dataStored))

            this.$router
                .push("/" + this.next + "-step/" + this.code)
                .catch(() => {});

        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        formatImporte(importe){
        if(!isNaN(importe)){
            return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
            }
        return importe;
        },

        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                // Quitado el punto: && charCode !== 46
                evt.preventDefault();;
            } else {
                return true;
            }
        },


    },


    }

</script>
<style lang="scss">

#social-security {
    // Something overflows (a div) - to avoid sideways scroll
    // corta el primer bocadillo si se pone
    // overflow: hidden !important;
    
    .legend{
        display: flex !important;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: center;
        justify-content: space-evenly;
        align-items: center;
    }

    .box{
        min-height:20px !important;
        min-width: 20px !important;
        height:20px !important;
        width: 20px !important;
        margin-right: 3px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

    }

    .modify-div {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-content: stretch;
        align-items: stretch;
        justify-content: center;
    }
   
    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }


    @media screen and (max-width: 490px) {   
        .legend{
            display: flex !important;
            flex-wrap: nowrap;
            flex-direction: column;
            align-content: flex-start;
            justify-content: space-evenly;
            align-items: flex-start;

            .legend-label{
                padding-top: 5px;
                text-align:left;
            }
        }
    }

    @media screen and (max-width: 799px) {

        .chart{
            width: 100% !important;
            margin: auto;
        }


    }

    @media only screen and (min-width : 800px)
  and (max-width : 1110px) {

        .chart{
            width: 50% !important;
            margin: 0;
        }

    }

    // @media screen and (min-width: 851px) {
    @media screen and (min-width: 1101px) {

        .chart{
            width: 33% !important;
            margin: 0;
        }

    }
}
</style>